import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { init as SentryInit } from '@sentry/angular-ivy';
// import { BrowserTracing } from '@sentry/tracing';
import { appConfig } from './app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

SentryInit({
  dsn: 'https://f2ba0c9cbcc347ff992faf283bb386b6@o1075862.ingest.sentry.io/6076852',
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    // new BrowserTracing({
    //   tracePropagationTargets: [
    //     'localhost',
    //     'picflow.io',
    //     'https://dev.picflow.com',
    //     'https://test.picflow.com',
    //     'https://picflow.com',
    //   ],
    //   routingInstrumentation: Sentry.routingInstrumentation,
    // }),
    // new Sentry.Replay(),
  ],
  release: '1.0.139-86a986891926f9d4330c6066bd119831a1a0d288',
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'gsi/client',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // Random errors that we know are safe
    'Unknown Error',
    'ChunkLoadError',
    'Blocked a frame with origin',
    '@webkit-masked-url(://hidden/)',
    'Minified invariant',
    'clearTransInfo',
    'needMaskingText',
    'styleSheetObserver',
    'clarity.js',
    'Ar.version',
    'googleads.g.doubleclick.net',
    '/gsi/client',
    '/clarity',
    'Lr.version',
    'this.elContainer.parentElement.insertBefore', // pinterest
    'ResizeObserver loop completed with',
    'The operation was aborted',
    '_sm_nck',
    'viewthroughconversion',
    'Fr.version',
    "reading 'version')",
    'Unable to auto-detect a suitable renderer.',
    'NoDecodeDelegateForThisImageFormat',
    'type=error',
  ],
  denyUrls: [
    'googletagmanager',
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    'https://snid.snitcher.com',
    '/analytics-dot-js-integrations/',
    '/next-integrations/',
    '_sm_nck',
    'clarity.js',
    'intercomcdn.com',
  ],
  // tracesSampler: samplingContext => {
  //   const pageName = samplingContext.transactionContext.name || '';
  //   if (pageName === '/') return 0.01;
  //   if (pageName === '/auth/authorize') return 0.01;
  //   if (pageName.startsWith('/access')) return 0.01;
  //   if (pageName.includes('/review/')) return 0.01;
  //   return 0.02;
  // },
});

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
